import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Navigation from "@/components/wedding/Navigation";
import Footer from "@/components/wedding/Footer";
import RSVPForm from "@/components/wedding/RSVPForm";

const CHURCH_IMG =
  "https://static.prod-images.emergentagent.com/jobs/2cf1c386-8bf6-4b35-9508-22a3e6aba20d/images/463afb0974443530c6777e45c327f4b7a41e7c7830371f4838e7411fa31b9bef.png";

export default function RSVPPage() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
    const prev = document.title;
    document.title = "RSVP · Michelle & Niall · 4 June 2027";
    return () => { document.title = prev; };
  }, []);

  return (
    <div className="min-h-screen bg-[#FAF9F6] text-[#1A1818]">
      <Navigation />
      <main>
        {/* Hero banner */}
        <section className="relative h-[45vh] min-h-[340px] w-full overflow-hidden">
          <img
            src={CHURCH_IMG}
            alt="St. Joseph's Church, Galway"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#6A1E2D]/95 via-[#1A1818]/60 to-[#1A1818]/30" />
          <div className="relative z-10 h-full max-w-7xl mx-auto px-6 md:px-10 flex flex-col justify-end pb-10 md:pb-12">
            <Link
              to="/"
              data-testid="rsvp-back-link"
              className="self-start inline-flex items-center gap-2 text-xs tracking-luxe uppercase text-[#FAF9F6] hover:text-[#A3C1DA] mb-auto pt-24 md:pt-28 group"
            >
              <ArrowLeft className="w-3.5 h-3.5 group-hover:-translate-x-0.5 transition-transform" strokeWidth={1.6} />
              Back to home
            </Link>
            <p className="text-[10px] tracking-luxe uppercase text-[#A3C1DA] mb-4">
              The favour of a reply
            </p>
            <h1 className="font-display font-light text-4xl md:text-6xl lg:text-7xl text-[#FAF9F6] leading-[0.95] max-w-3xl">
              Will you
              <span className="italic"> join us?</span>
            </h1>
          </div>
        </section>

        <RSVPForm />
      </main>
      <Footer />
    </div>
  );
}
